export default __webpack_public_path__ + "static/Wifi-4G-572199d67e927c82881af5f68e614be1.png";